import { useState } from "react";
import { Button } from "../components/Elements";
import Filters from "../components/PaymentLinks/Filters";
import LinksTable from "../components/PaymentLinks/LinksTable";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { buttonTexts } from "../../constants/texts/buttonTexts";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";
import { sendTypeIds } from "../../constants/options/sendOptions";

const initialValues = {
  startDate: "",
  endDate: "",
  sendType: 0,
  linkStatus: 0,
  paymentProvider: 0,
  paymentStatus: 0,
  startAmount: 0,
  endAmount: 0,
  customerName: "",
  email: "",
  phone: "",
  invoiceNumber: "",
};

export default function PaymentLinks() {

  usePermissionCheck(UserOperationTypes["Ödeme Linki Gönder"], "Ödeme Linki İşlemleri izni yok", "gonderilen-odeme-linkleri");
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [requestParameters, setRequestParameters] = useState(initialValues);

  return (
    <div className="w-full">
      <PageTitle title={pageTitleTexts.paymentLink} />
      <div className="px-4 pt-2 flex flex-row items-center justify-between space-y-2">
        <div className="flex flex-row items-center">
          <img src={"/icons/serbest-odeme-baslat-dark.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Gönderilen Ödeme Linkleri
          </span>
        </div>

        <div className=" flex flex-row justify-end items-center px-2">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
      </div>
      <Filters
        isOpen={filtersIsOpen}
        setFiltersIsOpen={setFiltersIsOpen}
        page={page}
        pageSize={pageSize}
        setRequestParameters={setRequestParameters} />
      <LinksTable
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
        requestParameters={requestParameters} />
    </div>
  );
}
